import './index.less'

import OldInviteNewReferral from './sections/old-invite-new-referral'

document.addEventListener('DOMContentLoaded', () => {
  // referral
  new OldInviteNewReferral()
})
